const features = [
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    desc: '采用多线路智能调度与CDN加速技术，自动匹配最优播放节点。无论热门大片还是冷门佳作，均能实现秒开即播，告别加载等待。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持流畅、高清、超清、4K多档画质自由切换，主流内容均提供1080P以上清晰度。配合自适应码率技术，网络不佳时自动降档不中断。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全免费',
    desc: '无需注册登录，无需付费订阅，所有影视内容永久免费在线观看。播放页面无弹窗广告，无恶意跳转，守护观影安全与体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">平台优势</h2>
          <p className="text-sm text-foreground-500">为什么选择爱豆影视？</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="text-center p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feat.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2.5">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}